import React from "react";
import AddIcon from "../Assets/svgs/AddIcon";
import { Tooltip } from "@mui/material";

const PlusIconBtn = ({ disabled, onClick }) => {
  return (
    <Tooltip
      title={disabled ? "You need to publish assistant first" : ""}
      placement="top"
      arrow
    >
      <button className="btn btn__primary" onClick={disabled ? null : onClick}>
        <AddIcon />
        Add
      </button>
    </Tooltip>
  );
};

export default PlusIconBtn;
